<div class="layout-container">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer [mode]="sidenavMode()" [opened]="shared.sidebarOpened()" class="left-sidebar" (openedChange)="onSidenavChange($event)">
      <div class="sidebar-header">
        <img [src]="images.broker_sidebar_large" [alt]="'NAV.LOGO'" class="brand-logo" />
      </div>
      <mat-nav-list [ngClass]="{ 'broker-list': userRole() === 'broker', 'stepper': userRole() === 'client' }">
        <ng-container *ngIf="userRole() === 'client'">
          <mat-vertical-stepper [linear]="false" [selectedIndex]="selectedIndex()"
            (selectionChange)="onStepChange($event.selectedIndex)">
            <mat-step *ngFor="let step of preferenceFormSteps(); let i = index" [completed]="isStepFinished(step, i)">
              <ng-template matStepLabel><span [ngClass]="{ 'step-complete': isStepFinished(step, i) }">{{
                step.label | i18nTranslate
                }}</span>
              </ng-template>
            </mat-step>
            <ng-template matStepperIcon="edit" let-index="index">
              <mat-icon>{{ isStepFinished(preferenceFormSteps()[index], index) ? 'check_circle' : 'edit' }}</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="done" let-index="index">
              <mat-icon>check_circle</mat-icon>
            </ng-template>
            <!-- The selected step always gets the number state, even when complete; show the tick for it too. -->
            <ng-template matStepperIcon="number" let-index="index">
              <mat-icon *ngIf="isStepFinished(preferenceFormSteps()[index], index)">check_circle</mat-icon>
            </ng-template>
          </mat-vertical-stepper>
        </ng-container>
        <ng-container *ngIf="userRole() === 'broker'">
          <div class="nav-list-top">
            <a mat-list-item *ngFor="let item of topNavItems()" [routerLink]="item.routerLink">
              <mat-icon matListItemIcon fontSet="material-icons-outlined">{{
                item.icon
                }}</mat-icon>
              <span matListItemTitle>
                {{ item.title | i18nTranslate }}
              </span>
            </a>
          </div>
          <div class="nav-list-bottom">
            <a mat-list-item *ngFor="let item of bottomNavItems()" [routerLink]="item.routerLink">
              <mat-icon matListItemIcon fontSet="material-icons-outlined">{{
                item.icon
                }}</mat-icon>
              <span matListItemTitle>
                {{ item.title | i18nTranslate }}
              </span>
            </a>
          </div>
        </ng-container>
      </mat-nav-list>
      <div class="sidebar-footer">
        <img [src]="images.InsureLiv_Logo" [alt]="'NAV.LOGO'"/>
        <div class="prod-subtitle">
          {{ "NAV.PRODUCT_SUBTITLE" | i18nTranslate }}
          <span class="prod-company">{{ "NAV.PRODUCT_COMPANY" | i18nTranslate }}
          </span>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <app-global-header [source]="isMotorPreferenceForm() ? 'motor-pref-form' : 'pref-form'" [showInsuranceProductSwitch]="false" class="profile-section">
      </app-global-header>
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- <button mat-icon-button class="profile-btn">
    <mat-icon>account_circle</mat-icon>
  </button> -->

  <!-- The motor preference form renders its own FAQ (app-motor-faq). -->
  <app-faq *ngIf="!isMotorPreferenceForm()"></app-faq>

  <div class="toggle-wrapper">
    <button mat-icon-button (click)="toggleMenu()" class="sidebar-toggle-btn" [class.sidebar-closed]="!drawer.opened">
      <mat-icon class="background-icon" svgIcon="icon-sidebar-toggle"></mat-icon>
      <mat-icon class="foreground-icon">{{  
        drawer.opened ? "close" : "menu"
        }}</mat-icon>
    </button>
  </div>
</div>